<script setup lang="ts">
const { getFormattedPrice, currencyCode } = usePrice();
const props = defineProps<{
  value: number | undefined;
}>();

const { value } = toRefs(props);

const { product } = useProduct();
const { price } = useProductPrice(product);
const { taxState } = useSessionContext();

const isNetPrice = ref(true);

const taxRate = computed(() => price.value?.taxRules?.[0]?.taxRate || 0);

const netPrice = computed(() => {
  if (!value.value) return value.value;
  return taxState.value === "gross"
    ? value.value / (1 + taxRate.value / 100)
    : value.value;
});

const grossPrice = computed(() => {
  if (!value.value) return value.value;
  return taxState.value === "gross"
    ? value.value
    : value.value * (1 + taxRate.value / 100);
});

const productPrice = computed(() =>
  isNetPrice.value ? netPrice.value : grossPrice.value
);

const getPrice = computed<string>(() => {
  // let numericPrice = parseFloat(
  //   getFormattedPrice(productPrice.value).replace(/\./g, "").replace(",", ".")
  // );
  const formattedPrice = new Intl.NumberFormat("de-CH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(productPrice.value || 0);

  return `${currencyCode.value} ${formattedPrice}`;
});
</script>

<template>
  <div>
    <div class="flex items-center text-skin-theme">
      <slot name="beforePrice" />
      <span>{{ getPrice }}</span>
      <slot name="afterPrice" />
      <select
        v-if="taxRate > 0"
        v-model="isNetPrice"
        class="min-w-min bg-transparent border-0 pr-10 ml-2 focus:ring-0"
      >
        <option :value="true">{{ $t("product.price.net") }}</option>
        <option :value="false">{{ $t("product.price.gross") }}</option>
      </select>
    </div>
    <p class="text-xs p-2">
      {{
        isNetPrice
          ? $t("product.price.excludingTax", { taxRate })
          : $t("product.price.includingTax", { taxRate })
      }}
    </p>
  </div>
</template>
